import {Input} from "../../../../../../Component/Input";
import {useCreateTeacherForm} from "../../hook/useCreateTeacherForm";

export const Identity = ()=>{
    const {identify} = useCreateTeacherForm()
    const {methods} = identify
    
    return (
        <Input
            label='Số CCCD'
            value={identify?.value}
            onChange={e => methods.onChange(e.target?.value)}
            onBlur={e => methods.onBlur(e.target?.value)}
            validateText={identify?.message}
            validateType={identify?.status ? 'danger' : ''}
            placeholder='Vui lòng nhập số CCCD'
        />
    )
}